// Function to generate a random pastel color
const generatePastelColor = () => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 70%, 80%)`;
  };
  
  // Function to generate a random dark color for shapes
  const generateDarkColor = () => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 70%, 30%)`;
  };
  
  // Function to generate SVG shapes
  const generateShapes = () => {
    const shapes = [];
    const numShapes = 3 + Math.floor(Math.random() * 4); // 3-6 shapes
  
    for (let i = 0; i < numShapes; i++) {
      const shapeType = Math.random() > 0.5 ? 'circle' : 'rect';
      const x = Math.floor(Math.random() * 100);
      const y = Math.floor(Math.random() * 100);
  
      if (shapeType === 'circle') {
        const radius = 10 + Math.floor(Math.random() * 30);
        shapes.push(`<circle cx="${x}%" cy="${y}%" r="${radius}" fill="${generateDarkColor()}" opacity="0.2" />`);
      } else {
        const width = 20 + Math.floor(Math.random() * 40);
        const height = 20 + Math.floor(Math.random() * 40);
        const rotation = Math.floor(Math.random() * 360);
        shapes.push(
          `<rect x="${x}%" y="${y}%" width="${width}" height="${height}" 
           transform="rotate(${rotation} ${x} ${y})" fill="${generateDarkColor()}" opacity="0.2" />`
        );
      }
    }
  
    return shapes.join('');
  };
  
  // Generate a unique background for a template
  export const generateTemplateBackground = (templateName: string) => {
    const backgroundColor = generatePastelColor();
    const shapes = generateShapes();
  
    return `data:image/svg+xml,${encodeURIComponent(`
      <svg width="250" height="140" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="${backgroundColor}" />
        ${shapes}
        <text 
          x="50%" 
          y="50%" 
          font-family="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', sans-serif" 
          font-size="48" 
          font-weight="bold" 
          fill="#000" 
          text-anchor="middle" 
          dominant-baseline="middle" 
          opacity="0.8"
          letter-spacing="2"
        >
          ${templateName.slice(0, 2).toUpperCase()}
        </text>
      </svg>
    `)}`;
  }; 
  